<template>
  <div>
    <div v-if="contractNumberModal" class="overlay"></div>
      <b-modal size="xl" id="myModal" v-model="show" title="MyBenefit Revamp" content-class="custom-modal" hide-footer @hide="onHide">
        <div v-if="contractNumberModal" class="overlay"></div>
        <b-tabs>
          <b-tab title="Coming soon" active><br>
            <b-form @submit.prevent="onSubmit" @reset="onClose" v-loading="loading.company_detail">
              <b-container class="bv-example-row">
                <b-row>
                  <b-col>
                    <b-form-group label="Package">
                      <el-select size="small" class="mb-2 mr-2" :loading="loading.package_list" v-model="form_old.package_id" placeholder="Select package" @change="handlerSelectPackage">
                        <el-option
                          v-for="item in package_list"
                          :key="item.id"
                          :label="item.package_name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </b-form-group>
                  </b-col>
                  <b-col> 
                    <b-form-group label="Effective Date">
                      <el-date-picker v-model="form_old.mybenefit_start_at"
                        :picker-options="datePickerOptions"/>
                    </b-form-group>
                  </b-col>
                  <div class="w-100"></div>
                  <b-col>
                    <b-form-group label="Cut Off Date">
                      <el-select size="small" class="mb-2 mr-2" v-model="form_old.payoff_date" placeholder="Select date">
                        <el-option
                          v-for="option in options"
                          :value="option"
                          :label="option"
                          :key="option">
                        </el-option>
                      </el-select>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Payroll Date">
                      <el-select size="small" class="mb-2 mr-2" v-model="form_old.payroll_date" placeholder="Select date">
                        <el-option
                          v-for="option in options"
                          :value="option"
                          :label="option"
                          :key="option">
                        </el-option>
                      </el-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <hr class="mb-4">
                <b-row>
                  <b-col>
                    <b-form-group label="Total Employee Salary (Rp)">
                       <el-input disabled v-model="formattedTotalSalary" placeholder="Rp.0"/>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Total Employees">
                       <el-input disabled v-model="total_employee" placeholder="Rp.0"/>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Limit Company (Rp)">
                      <el-input v-model="formattedMaxBalancee" placeholder="Rp.0"/>
                    </b-form-group>
                  </b-col>
                </b-row>
                <hr class="mb-4">
                <!-- NEW DESIGN -->
                <div style="width: 100%; overflow-x: auto;">
                  <el-table :data="form.features" style="min-width: 800px">
                    <el-table-column prop="name" label="Feature Name" width="180" />
                    <el-table-column label="Enabled" width="140">
                      <template #default="{ row }">
                        <el-switch
                          v-model="row.is_enabled"
                          :disabled="row._disabled"
                          active-color="#13ce66"
                          inactive-color="#ff4949"
                          active-text="Yes"
                          inactive-text="No"
                          @change="handleFeatureToggle(row)"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column width="80" label="Version">
                      <template #default="{ row }">
                        <el-input
                          v-model="row.version"
                          size="mini"
                          disabled
                        />
                      </template>
                    </el-table-column>
                    <el-table-column width="140" prop="max_percentage">
                      <template #header>
                        <el-tooltip content="*Cannot be more than 100% of salary" placement="top">
                          <span>Limit Feature(%)</span>
                        </el-tooltip>
                      </template>
                      <template #default="{ row }">
                        <el-input
                          v-if="shouldShowMP(row)"
                          v-model.number="row.max_percentage"
                          placeholder="0"
                          size="small"
                          type="number" 
                          :max="getMaxLimit(row)"
                          :min="0"
                          @input="handleMaxPercentageInput(row)"
                        />
                        <span v-if="isSubmitDisabled && shouldShowMP(row) && !row.max_percentage" class="text-danger text-xs ml-2" >
                          *Required
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column width="140" label="Min Percentage(%)">
                      <template #default="{ row }">
                          <el-input
                            v-if="shouldShowAF(row)"
                            v-model.number="row.min_percentage"
                            placeholder="0"
                            size="small"
                            type="number"
                            :max="10"
                            :min="0"
                          />
                          <!-- @blur="handleMinPercentageBlur(row)" -->
                      </template>
                    </el-table-column>
                    <el-table-column width="150" label="Admin Fee( %)">
                      <template #default="{ row }">
                        <b-input
                          v-if="shouldShowAF(row)"
                          v-model.number="row.admin_fee"
                          placeholder="0"
                          type="number"
                          :min="0"
                          :max="10"
                        />
                          <!-- @blur="handleAdminFeeBlurr(row)" -->
                      </template>
                    </el-table-column>
                    <el-table-column width="120" label="Min Fee">
                      <template #default="{ row }">
                        <el-input
                          v-if="shouldShowAF(row)"
                          v-model.number="row.min_fee"
                          placeholder="25.000"
                          type="number"
                          :min="0"
                          :max="100000"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column width="140" label="Full Limit(days)">
                      <template #default="{ row }">
                        <el-input
                          v-if="shouldShowDays(row)"
                          v-model.number="row.force_full_limit_in"
                          placeholder="10"
                          type="number"
                          :min="0"
                          :max="10"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column width="130" label="Insurance Type">
                      <template #default="{ row }">
                        <el-select
                          v-if="shouldShowTenor(row)"
                          v-model="row.insurance_fee_type"
                          placeholder="Select"
                          size="small"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="option in admin_fee_type_options"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value"
                          />
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column width="120" label="Insurance fee">
                      <template #default="{ row }">
                        <el-input
                          v-if="shouldShowTenor(row)"
                          v-model="row.insurance_fee"
                          placeholder="Rp.0"
                          type="number"
                          size="small"
                        /> 
                      </template>
                    </el-table-column>
                    <!-- <el-table-column width="120" label="Processing fee">
                      <template #default="{ row }">
                        <el-input
                          v-if="shouldShowTenor(row)"
                          v-model="row.processing_fee"
                          placeholder="Rp.0"
                          type="number"
                          size="small"
                          :min="0"
                          :max="100000"
                        /> 
                      </template>
                    </el-table-column> -->
                     <el-table-column width="150" label="Processing Fee Type">
                      <template #default="{ row }">
                        <el-select
                          v-if="shouldProcessing(row)"
                          v-model="row.processing_fee_type"
                          placeholder="Select"
                          size="small"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="option in admin_fee_type_options"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value"
                          />
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column width="120" label="Processing fee">
                      <template #default="{ row }">
                        <el-input
                          v-if="shouldShowTenor(row)"
                          v-model.number="row.processing_fee"
                          placeholder="Rp.0"
                          type="number"
                          size="small"
                          :min="0"
                          :max="row.processing_fee_type === 'fix' ? 100000 : 100"
                          :step="row.processing_fee_type === 'percentage' ? 0.1 : 1"
                        /> 
                          <!-- @blur="handleProcessingFeeBlur(row)" -->
                      </template>
                    </el-table-column>
                     <!-- <el-table-column width="150" label="Min Processing Fee">
                      <template #default="{ row }">
                        <el-input
                          v-if="shouldProcessing(row)"
                          v-model.number="row.minimum_request"
                          placeholder="10.000"
                          type="number"
                          :min="0"
                          :max="100000"
                        />
                      </template>
                    </el-table-column> -->
                    <el-table-column width="100" label="Tenor">
                      <template #default="{ row }">
                        <el-select
                          v-if="shouldShowTenor(row)"
                          v-model="row.repayment_terms"
                          placeholder="Select Tenor"
                          size="small"
                          style="width: 100%"
                          multiple
                        >
                          <el-option
                            v-for="option in tenor_options"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value"
                          />
                        </el-select>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <hr class="mb-4">
                <div class="d-flex float-right mt-2">
                <el-button :disabled="isSubmitDisabled" @click="onSubmit" class="mr-2 ml-2" size="small" type="primary" >Submit Request</el-button>
                <el-button @click="onHide" size="small" class="mr-2">Close</el-button>
              </div>
              </b-container><br>
            </b-form>
            <el-dialog :visible.sync="contractNumberModal" @close="cancelCN()" title="Input Contract Number"  :modal="false" :append-to-body="false" width="30%">
              <el-form label-width="100px">
                <el-form-item label="No. PKS" prop="" required>
                  <el-input class="mb-2" v-model.trim="modal.contactNumber" placeholder="Input PKS Number"></el-input><br>
                </el-form-item>
                <el-form-item label="Existing" prop="" required>
                  <p>Contract Number: {{ savedContactNumber }}</p>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="cancelCN()">Cancel</el-button>
                <el-button @click="submitCN()" type="primary">Submit</el-button>
              </span>
          </el-dialog>
          </b-tab>
        </b-tabs>
      </b-modal>
  </div>
</template>
<script>
import moment from 'moment';
import useVuelidate from '@vuelidate/core';
import {
  required, requiredIf, numeric,
} from '@vuelidate/validators';
import {
  GET_MYBENEFIT, GET_MYBENEFIT_DETAIL, ASSIGN_PACKAGE,
} from '@/store/modules/mybenefit';
import {
  DETAIL_COMPANIES, DETAIL_MYBEN_BY_COMPANY, GET_TOTAL_SALARY_COMPANIES
} from '@/store/modules/companies';
import popupErrorMessages from '@/library/popup-error-messages';
import CreatePackage from '../mybenefit/CreatePackage.vue';

export default {
  components: { CreatePackage },
  name: 'MyBenefitModal',
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  validations() {
    return {
      form_old: {
        package_id: { required },
        mybenefit_start_at: { required },
        is_enabled_ewa: { required },
        is_enabled_reimburse: { required },
        is_enabled_gajianduluan: { required },
        payoff_date: {
          required
        },
        payroll_date: {
          required
        },
        admin_fee_ewa: {
          required: requiredIf(this.form_old.is_enabled_ewa),
        },
        ewa_req_limit: {
          required: requiredIf(this.form_old.is_enabled_ewa),
        },
      },
    };
  },
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    selectedCompany: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    const periodLength = 12;
    const tenorOptions = [];

    for (let index = 1; index <= periodLength; index++) {
      tenorOptions.push({ label: index.toString(), value: index });
    }
    return {
      modal: {
        contactNumber: ''
      },
      savedContactNumber: '',
      selectedRow: null,
      id: 0,
      selectedFeature: null,
      contactNumber: '',
      contractNumberModal: false,
      formattedGadunLimit: '',
      formattedAdminFeeAwa: '',
      formattedAwaReqLimit: '',
      packetNames: '',
      packet: '',
      ewaRequestLimit: '',
      total_salary: 0,
      total_employee: 0,
      adminFeeType: '',
      adminFeeEwa: '',
      DataEwaTier: [],
      show: false,
      loading: {
        package_list: false,
        benefit_detail: false,
        assign_package: false,
        company_detail: false,
      },
      package_list: [],
      form_old: {
        test: 0,
        package_id: '',
        tenor: '',
        repayment_terms: '',
        loan_tracker_company_id: '',
        mybenefit_start_at: moment().format('YYYY-MM-DD'),
        is_enabled_ewa: false,
        is_enabled_reimburse: false,
        payoff_date: '',
        payroll_date: '',
        admin_fee: '',
        interest_fee: '',
        admin_fee_ewa: '',
        ewa_req_limit: '',
        is_enabled_gajianduluan: false,
        feature: {
          feature_name: ''
        },
        is_enabled_awa: true,
        is_enabled_gop: true,
        company_id: '',
        company_policy: {
          max_balance_disbursement: 0,
          salary_burden_percentage: 40,
          alert_method: 'email',
          total_limit_percentage: 100,            
        }
      },
      form: {
        package_id: '',
        tenor: '',
        repayment_terms: '',
        force_full_limit_in: '',
        loan_tracker_company_id: '',
        mybenefit_start_at: moment().format('YYYY-MM-DD'),
        is_enabled_ewa: false,
        is_enabled_reimburse: false,
        payoff_date: '',
        payroll_date: '',
        admin_fee: '',
        interest_fee: '',
        admin_fee_ewa: '',
        ewa_req_limit: '',
        is_enabled_gajianduluan: false,
        // NEW
         product_setting: {
          ewa_v2: {
            active: true,
            max_percentage: 30,
            contract_number: '',
            always_on: true,
            admin_fee_type: 'percentage',
            admin_fee_deduct: 'upfront',
            admin_fee: {
              base_percentage: 3.0,
              min_fee: 25000,
              min_percentage: 2.3,
            },
          },
          awa_v1: {
            active: true,
            max_percentage: 40,
            contract_number: '',
            admin_fee_type: 'percentage',
            admin_fee_deduct: 'upfront',
            admin_fee: {
              base_percentage: 3.0,
              min_fee: 25000,
              min_percentage: 2.3,
            },
            repayment_terms: [],
            force_full_limit_in: 0
          },
          gop_v1: {
            active: true,
            max_percentage: 30,
            contract_number: '',
            admin_fee_type: 'percentage',
            repayment_terms: []
          },
        }, 
        company_policy: {
          max_balance_disbursement: 0,
          salary_burden_percentage: 40,
          alert_method: 'email',
          total_limit_percentage: 100,            
        },
        // feature: {
        //   feature_name: '',
        //   feature_id: [],
        //   feature_version: ''
        // },
        features: [],
        is_enabled_awa: true,
        is_enabled_gop: true,
        company_id: '',
      },
      datePickerOptions: {
      },
      benefit_list: [],
      salary: [],
      showModalCreatePackage: false,
      options:[],
      admin_fee_type_options: [
        {
          label: 'Percentage',
          value: 'percentage',
        },
        {
          label: 'Fixed',
          value: 'fix',
        },
      ],
      tenor_options: tenorOptions
    };
  },
  methods: {
    handleProcessingFeeBlur(row) {
      const isFix = row.processing_fee_type === "fix";
      const min = 0;
      const max = isFix ? 100000 : 100;
      let value = Number(row.processing_fee) || 0;
      if (value < min) value = min;
      if (value > max) value = max;
      if (!isFix) {
        value = Math.round(value * 10) / 10; 
      } else {
        value = Math.round(value);
      }
      row.processing_fee = value;
    },
    handleAdminFeeBlur(row) {
      const min = 3;
      if (!row.admin_fee || row.admin_fee < min) {
        row.admin_fee = min;
      }
    },
    handleAdminFee(row) {
      if (row.admin_fee < 3 || isNaN(row.admin_fee)) {
        row.admin_fee = 3;
      } else {
      }
    },
    handleMinBasePercentageFee(row) {
      if (row.min_percentage !== '' && row.min_percentage < 2.3) {
        row.min_percentage = 2.3;
      }
    },
    handleMaxPercentageInput(row) {
      const limit = this.getMaxLimit(row);
      if (row.max_percentage > limit) {
        row.max_percentage = limit;
      } else if (row.max_percentage < 0) {
        row.max_percentage = 0;
      }
    },
    getMaxLimit(row) {
      if (!row.is_enabled) return 0;
      const isEwa = row.slug === 'ewa' && row.version === 'v2';
      const isGop = row.slug === 'gop' && row.version === 'v1';
      const isAwa = row.slug === 'awa' && row.version === 'v1';
      const relevantKeys = ['ewa:v2', 'gop:v1', 'awa:v1'];
      const totalOthers = this.form.features.reduce((sum, item) => {
        const isRelevant =
          item.slug && item.version &&
          `${item.slug}:${item.version}` !== `${row.slug}:${row.version}` &&
          item.is_enabled &&
          relevantKeys.includes(`${item.slug}:${item.version}`);
        if (isRelevant) {
          return sum + parseInt(item.max_percentage || 0);
        }
        return sum;
      }, 0);
      const remaining = Math.max(0, 100 - totalOthers);
      if (isEwa) {
        return Math.min(100, remaining);
      }
      return remaining;
    },
    shouldShowFeeType(row) {
      return row.is_enabled && ['awa', 'gop'].includes(row.slug);
    },
    shouldShowTenor(row) {
      return row.is_enabled && ['awa', 'gop'].includes(row.slug);
    },
    shouldProcessing(row) {
      return row.is_enabled && ['awa'].includes(row.slug);
    },
    shouldShowMP(row) {
      return row?.is_enabled && (
        (row.slug === 'ewa' && row.version === 'v2') ||
        (['awa', 'gop'].includes(row.slug) && row.version === 'v1')
      );
    },
    shouldShowAF(row) {
      return row?.is_enabled && (
        (row.slug === 'ewa' && row.version === 'v2') ||
        (['awa', 'gop'].includes(row.slug) && row.version === 'v1')
      );
    },
    shouldShowLimit(row) {
      return row?.is_enabled && (
        (row.slug === 'ewa' && row.version === 'v1')
      );
    },
    shouldShowDays(row) {
      return row?.is_enabled && (
        (row.slug === 'ewa' && row.version === 'v2')
      );
    },
    handleFeatureToggle(feature) {
      this.modal.contactNumber = '';
      this.selectedFeature = feature;
      const featureKey = `${feature.slug}_${feature.version}`;
      const featureWithContract = this.form.features.find(f => {
        return f.contract_number && f.contract_number[featureKey];
      });
      let contractNumber = '-';
      if (featureWithContract) {
        contractNumber = featureWithContract.contract_number[featureKey]?.contract_number ?? '-';
      }
      this.modal.contractNumber = contractNumber;
      this.savedContactNumber = contractNumber;
      if (feature.is_enabled) {
        this.contractNumberModal = true;
        return; 
      }
      this.processFeatureToggleLogic(feature);
    },
    onContractNumberConfirmed() {
      const contact = this.modal.contactNumber?.trim();
      if (!contact) {
        this.$message.error('Contact number is required.');
        this.contractNumberModal = false;

        if (this.selectedFeature) {
          this.$nextTick(() => {
            this.selectedFeature.is_enabled = false;
            const index = this.form.features.findIndex(f => f.id === this.selectedFeature.id);
            if (index !== -1) {
              this.$set(this.form.features, index, { ...this.selectedFeature });
            }
          });
        }
        return;
      }
      this.contractNumberModal = false;
      this.processFeatureToggleLogic(this.selectedFeature);
    },
    processFeatureToggleLogic(feature) {
      const isEwa = feature.slug === 'ewa';
      const isEwaV1 = isEwa && feature.version === 'v1';
      const isEwaV2 = isEwa && feature.version === 'v2';
      this.form.features.forEach(f => { f._disabled = false });
      if (isEwaV1 && feature.is_enabled) {
        const ewaV2 = this.form.features.find(f => f.slug === 'ewa' && f.version === 'v2');
        if (ewaV2) {
          ewaV2._disabled = true;
          ewaV2.is_enabled = false;
        }
        this.form.features.forEach(f => {
          if (f.slug !== 'ewa' && f.slug !== 'gadun' && f.slug !== 'reimburse') {
            f._disabled = true;
            f.is_enabled = false;
          }
        });
      }
      if (isEwaV1 && !feature.is_enabled) {
        this.form.features.forEach(f => { f._disabled = false });
      }
      if (isEwaV2 && feature.is_enabled) {
        const ewaV1 = this.form.features.find(f => f.slug === 'ewa' && f.version === 'v1');
        if (ewaV1) {
          ewaV1._disabled = true;
          ewaV1.is_enabled = false;
        }
      }
      if (isEwaV2 && !feature.is_enabled) {
        const ewaV1 = this.form.features.find(f => f.slug === 'ewa' && f.version === 'v1');
        if (ewaV1) {
          ewaV1._disabled = false;
        }
      }
      if (feature.slug === 'ewa') this.form.is_enabled_ewa = feature.is_enabled;
      if (feature.slug === 'reimburse') this.form.is_enabled_reimburse = feature.is_enabled;
      if (feature.slug === 'gadun') this.form.is_enabled_gajianduluan = feature.is_enabled;
      this.form.features_id = this.form.features
        .filter(f => f.is_enabled)
        .map(f => f.id);
    },
    addEwaTier() {
      this.DataEwaTier.push({
        packet_name: '',
        ewa_req_limit: null,
        admin_fee_ewa: null,
        admin_fee_type: ''
      });
    },
    removeEwaTier(index) {
      this.DataEwaTier.splice(index, 1);
    },
    handleMinPercentageBlur(row) {
      if (
        row.min_percentage === undefined ||
        row.min_percentage === null ||
        row.min_percentage >= row.admin_fee
      ) {
        // row.min_percentage = 2.3;
        row.min_percentage = 0;
      }
    },
    handleAdminFeeBlurr(row) {
      if (
        row.admin_fee === undefined ||
        row.admin_fee === null ||
        row.min_percentage >= row.admin_fee
      ) {
        // row.admin_fee = 3;
        row.admin_fee = 0;
      }
    },
    onHide() {
      this.$emit('onHide');
    },
    async loadTotalSalaryEmployeeList() {
      this.loading.company_detail = true;
      try {
        const result = await this.$store.dispatch(
          GET_TOTAL_SALARY_COMPANIES,
          { id: this.selectedCompany.company_id }
        );
        this.total_salary = result?.data?.total_salary ?? 0;
        this.total_employee = result?.data?.total_employee ?? 0;

      } catch (err) {
        console.error(err);
      } finally {
        this.loading.company_detail = false;
      }
    },
    async loadMyBenefitList() {
      this.loading.package_list = true;
      await this.$store.dispatch(GET_MYBENEFIT).then((response) => {
        this.package_list = response.rows;
        this.loadBenefitDetail();
      });
      this.loading.package_list = false;
    },
    async loadBenefitDetail() {
        if (!this.form_old.package_id) {
          return;
        }
        this.loading.benefit_detail = true;
        await this.$store.dispatch(GET_MYBENEFIT_DETAIL, {
          id: this.form_old.package_id,
        }).then(() => {
          this.benefit_list = this.$store.getters.benefit_list;
        });
        this.loading.benefit_detail = false;
      },
      async loadCompanyDetail() {
        this.loading.company_detail = true;
        await this.$store.dispatch(DETAIL_MYBEN_BY_COMPANY, {
          id: this.selectedCompany.company_id,
        })
        .then(({ data }) => {
          const rows = data.rows ?? [];
          const firstId = rows[0]?.id;
          const firstCompanyId = rows[0]?.company_id;
          this.form = {
            package_id: data.mybenefit_package_id == 0 ? '' : data.mybenefit_package_id,
            mybenefit_start_at: data.mybenefit_package_start_at 
              ? moment(data.mybenefit_package_start_at).format('YYYY-MM-DD') 
              : '',
            is_enabled_ewa: data.is_enabled_ewa,
            is_enabled_reimburse: data.is_enabled_reimburse,
            is_enabled_gajianduluan: data.is_enabled_gajianduluan,
            payoff_date: data.setting?.payoff_date,
            payroll_date: data.setting?.payroll_date,
            admin_fee_ewa: data.setting?.admin_fee_ewa || 0,
            ewa_req_limit: data.setting?.ewa_req_limit || 0,
            interest_fee: data.company_loan_rate?.interest_rate,
            admin_fee: data.company_loan_rate?.admin_fee_rate,
            loan_tracker_company_id: data.loan_tracker_company_id,
            company_policy: {
              max_balance_disbursement: 0,
              salary_burden_percentage: 30,
              alert_method: 'email',
              total_limit_percentage: 100,
            },
            features: rows.map(item => ({
              id: item.feature?.feature_id,
              name: item.feature?.feature_name,
              slug: item.feature?.feature_slug,
              version: item.feature?.feature_version,
              is_enabled: item.is_enabled,
              admin_fee: item.config?.admin_fee?.base_percentage ?? 3,
              min_percentage: item.config?.admin_fee?.min_percentage ?? 2.3,
              min_fee: item.config?.admin_fee?.min_fee ?? 0,
              admin_fee_type: item.config?.admin_fee_type ?? "percentage",
              admin_fee_deduct: item.config?.admin_fee_deduct || null,
              repayment_terms: item.config?.repayment_terms || [6],
              _disabled: false,
              max_percentage: item.config?.max_percentage || null,
              force_full_limit_in: item.config?.force_full_limit_in || 10,
              insurance_fee_type: item.config?.insurance_fee_type || "percentage",
              insurance_fee: item.config?.insurance_fee ?? 0,
              processing_fee: item.config?.processing_fee ?? 0, 
              processing_fee_type: item.config?.processing_fee_type ?? "fix", 
              contract_number: item.config?.product_setting ?? "-", 
              // minimum_request: item.config?.minimum_request ?? 10000, 
            })),

          };

          this.DataEwaTier = data.setting?.ewa_tier ?? [];
          this.loadBenefitDetail();
        })
        .catch((err) => {
        });
      this.loading.company_detail = false;
      },
    async loadCompanyDetailOld() {
      this.loading.company_detail = true;
      await this.$store.dispatch(DETAIL_COMPANIES, {
        id: this.selectedCompany.company_id,
      })
        .then(({ data }) => {
          this.form_old = {
            package_id: data.mybenefit_package_id === 0 ? '' : data.mybenefit_package_id,
            tenor: '',
            repayment_terms: '',
            loan_tracker_company_id: data.loan_tracker_company_id ?? '',
            mybenefit_start_at: data.mybenefit_package_start_at
              ? moment(data.mybenefit_package_start_at).format('YYYY-MM-DD')
              : '',
            is_enabled_ewa: data.is_enabled_ewa ?? false,
            is_enabled_reimburse: data.is_enabled_reimburse ?? false,
            is_enabled_gajianduluan: data.is_enabled_gajianduluan ?? false,
            is_enabled_awa: data.is_enabled_awa ?? false,
            is_enabled_gop: data.is_enabled_gop ?? false,
            payoff_date: data.setting?.payoff_date ?? '',
            payroll_date: data.setting?.payroll_date ?? '',
            admin_fee: data.company_loan_rate?.admin_fee_rate ?? '',
            interest_fee: data.company_loan_rate?.interest_rate ?? '',
            admin_fee_ewa: data.setting?.admin_fee_ewa ?? '',
            ewa_req_limit: data.setting?.ewa_req_limit ?? '',
            company_id: data.id ?? '',
            feature: {
              feature_name: data.feature?.feature_name ?? ''
            },
            company_policy: {
              max_balance_disbursement: data.setting?.company_policy?.max_balance_disbursement ?? 0,
              salary_burden_percentage: data.setting?.company_policy?.salary_burden_percentage ?? 0,
              alert_method: data.setting?.company_policy?.alert_method ?? '',
              total_limit_percentage: data.setting?.company_policy?.total_limit_percentage ?? 100
            },
          };

          this.DataEwaTier = data.setting?.ewa_tier ?? [];
          this.loadBenefitDetail();
        })
        .catch((err) => {
        });

      this.loading.company_detail = false;
    },
    submitCN(feature) {
      this.$nextTick(() => {
        if (!this.modal.contactNumber) {
          this.$message.error('Contract Number is required.');
          return;
        }
        localStorage.setItem('contactNumber', this.modal.contactNumber);
        this.contractNumberModal = false;
        this.selectedFeature = feature;
        this.processFeatureToggleLogic(feature);
      });
    },
    cancelCN() {
      this.contractNumberModal = false;
      if (this.selectedFeature) {
        this.selectedFeature.is_enabled = false;
        const index = this.form.features.findIndex(f => f.id === this.selectedFeature.id);
        if (index !== -1) {
          this.$set(this.form.features, index, { ...this.selectedFeature });
        }
      }
    },
    async onSubmit() {
      const pkg = (this.package_list || []).find(v => v.id === this.form_old.package_id);
      if (this.form_old.is_enabled_ewa || this.form_old.is_enabled_gajianduluan) {
        this.form_old.setting = {
          payoff_date: this.form_old.payoff_date,
          payroll_date: this.form_old.payroll_date,
          admin_fee_ewa: this.parseFormattedNumberNew(this.form_old.admin_fee_ewa),
          ewa_req_limit: this.parseFormattedNumberNew(this.form_old.ewa_req_limit),
        };
      }
      const product_setting = {};
      const savedContractNumber = localStorage.getItem('contactNumber') || '-';
      this.form.features.forEach(feature => {
        const key = `${feature.slug}_${feature.version}`;
        product_setting[key] = {
          active: feature.is_enabled,
          max_percentage: parseFloat(feature.max_percentage) || 0,
          // contract_number:  this.modal.contactNumber?.[key] || '003/VFI/PKS/LEGL/IX/2024',
          contract_number: savedContractNumber,
          always_on: true,
          admin_fee_type: 'percentage',
          admin_fee_deduct: feature.admin_fee_deduct || 'upfront',
          admin_fee: {
            base_percentage: parseFloat(feature.admin_fee) || 0,
            // min_fee: parseFloat(feature.min_fee) || 25000,
            min_fee: parseFloat(feature.min_fee) || 0,
            min_percentage: parseFloat(feature.min_percentage) || 0,
          },
          repayment_terms: feature.repayment_terms || [6],
          force_full_limit_in: feature.force_full_limit_in || 10,
          insurance_fee_type: feature.insurance_fee_type || "percentage",
          insurance_fee: parseFloat(feature.insurance_fee) || 0,
          processing_fee: parseFloat(feature.processing_fee) || 0,
          processing_fee_type: feature.processing_fee_type || "fix",

        };
      });
      try {
        await this.$store.dispatch(ASSIGN_PACKAGE, {
          id: this.form_old.package_id,
          data: {
            company_id: this.selectedCompany.company_id,
            mybenefit_start_at: this.form_old.mybenefit_start_at,
            is_enabled_ewa: this.form_old.is_enabled_ewa,
            is_enabled_reimburse: this.form_old.is_enabled_reimburse,
            is_enabled_gajianduluan: this.form_old.is_enabled_gajianduluan,
            setting: {
              admin_fee_ewa : this.form_old.admin_fee_ewa || 0,
              ewa_req_limit : this.form_old.ewa_req_limit || 0,
              //  admin_fee_ewa : 0,
              // ewa_req_limit : 0,
              payoff_date : this.form_old.payoff_date,
              payroll_date : this.form_old.payroll_date
            },
            company_policy: {
              max_balance_disbursement: this.form_old.company_policy.max_balance_disbursement || 327505000,
              salary_burden_percentage: 30,
              alert_method: "email",
              total_limit_percentage: 100,     
            },
            product_setting,
            is_enabled_awa: product_setting.awa_v1?.active || false,
            feature_ids: this.form.features.filter(f => f.is_enabled).map(f => f.id)
          },
        });
        localStorage.removeItem('contactNumber');
        this.$message({
          title: 'Success',
          type: 'success',
          message: 'Successfully submitted request',
        });
        this.onHide();
      } catch (err) {
        if (err.response) popupErrorMessages(err.response.data);
        console.error('Submission error:', err);
      }
    },
    resetForm() {
      // this.ewaTier = [];
      this.packetNames = "";
      this.ewaRequestLimit = "";
      this.adminFeeEwa = "";
      this.adminFeeType = "";
      this.packet = "";
    },
    onClose() {
      this.form = {
        package_id: '',
        mybenefit_start_at: moment().format('YYYY-MM-DD'),
        is_enabled_ewa: false,
        is_enabled_reimburse: false,
        is_enabled_gajianduluan: false,
        payoff_date: '',
        payroll_date: '',
        admin_fee_ewa: '',
        ewa_req_limit: '',
      };
      this.onHide();
      this.$emit('onClose');
    },
    handlerSelectPackage() {
      this.loadBenefitDetail();
    },
    doShowModalCreatePackage() {
      this.showModalCreatePackage = true;
    },
    handlerChangeEwaLoan(value, type) {
      if (this.form.is_enabled_ewa && this.form.is_enabled_gajianduluan) {
        if (type === 'ewa') {
          this.$set(this.form, 'is_enabled_gajianduluan', false);
        }
        if (type === 'loan') {
          this.$set(this.form, 'is_enabled_ewa', false);
        }
      }
    },
    formatNumberWithSeparator(value) {
      const stringValue = String(value);

      const numericValue = stringValue.replace(/[^0-9.]/g, '');

      const parts = numericValue.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    formatNumber(value) {
      if (typeof value !== 'string') {
        value = String(value);
      }

      value = value.replace(/[^0-9.]/g, '');

      const parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    parseFormattedNumber(value) {
      return value.replace(/,/g, '');
    },
    parseFormattedNumberNew(value) {
      const parsed = parseFloat(String(value).replace(/[^\d.]/g, ''));
      return isNaN(parsed) ? 0 : parsed;
    }
  },
  async mounted() {
      // this.loadTotalSalaryEmployeeList()
  },
  computed: {
    isSubmitDisabled() {
      const features = this.form.features || [];
      const ewa = features.find(f => f.slug === 'ewa' && f.version === 'v2' && f.is_enabled);
      const awa = features.find(f => f.slug === 'awa' && f.version === 'v1' && f.is_enabled);
      if (ewa && awa) {
        const ewaValid = !!ewa.max_percentage && parseInt(ewa.max_percentage) > 0;
        const awaValid = !!awa.max_percentage && parseInt(awa.max_percentage) > 0;
        return !(ewaValid || awaValid); // disable if both are zero/invalid
      }
      if (ewa) {
        return !ewa.max_percentage || parseInt(ewa.max_percentage) === 0;
      }
      if (awa) {
        return !awa.max_percentage || parseInt(awa.max_percentage) === 0;
      }
      return false;
    },
    isEwaEnabled() {
      return this.form.features?.some(f => f.slug === 'ewa' && f.is_enabled) ?? false;
    },
    isAwaEnabled() {
      return this.form.features.some(f => f.slug === 'awa' && f.is_enabled);
    },
    isGadunEnabled() {
      return this.form.features.some(f => f.slug === 'gadun' && f.is_enabled);
    },
    isReimburseEnabled() {
      return this.form.features.some(f => f.slug === 'reimburse' && f.is_enabled);
    },
    canAddEwaTier() {
      const lastRow = this.DataEwaTier[this.DataEwaTier.length - 1];
      return (
        // lastRow?.packet_name !== '' &&
        lastRow?.ewa_req_limit !== null &&
        lastRow?.admin_fee_ewa !== null &&
        lastRow?.admin_fee_type !== ''
      );
    },
    formattedAdminFeeEwa: {
        get() {
          return this.formatNumber(this.form_old.admin_fee_ewa);
        },
        set(value) {
          this.form_old.admin_fee_ewa = this.parseFormattedNumber(value);
        },
    },
    formattedEwaReqLimit: {
      get() {
        return this.formatNumber(this.form_old.ewa_req_limit);
      },
      set(value) {
        this.form_old.ewa_req_limit = this.parseFormattedNumber(value);
      },
    },
    formattedMaxBalancee: {
      get() {
        return this.formatNumber(this.form_old.company_policy.max_balance_disbursement);
      },
      set(value) {
        this.form_old.company_policy.max_balance_disbursement = parseInt(this.parseFormattedNumber(value), 10) || 0;
      }
    },
    formattedTotalSalary: {
      get() {
        return this.formatNumber(this.total_salary);
      },
      set(value) {
        this.total_salary = parseInt(this.parseFormattedNumber(value), 10) || 0;
      }
    },
  },
  created() {
    for (let i = 1; i <= 31; i++) {
      this.options.push(i);
    }
  },
  watch: {
    isShown() {
      this.show = this.isShown;
      if (this.show) {
        this.form_old.package_id = this.selectedCompany.mybenefit_package_id;
        this.id = this.selectedCompany.company_id;
        this.v$.form_old.$touch();
        this.loadMyBenefitList();
        this.loadCompanyDetail();
        this.loadCompanyDetailOld();
        this.loadTotalSalaryEmployeeList()
      }
    },
    'form.features': {
      handler(newFeatures) {
        const relevantKeys = ['ewa:v2', 'gop:v1', 'awa:v1'];
        const feature100 = newFeatures.find(f => 
          f.is_enabled &&
          relevantKeys.includes(`${f.slug}:${f.version}`) &&
          f.max_percentage === 100
        );

        if (feature100) {
          this.form.features.forEach(f => {
            if (
              f.is_enabled &&
              relevantKeys.includes(`${f.slug}:${f.version}`) &&
              `${f.slug}:${f.version}` !== `${feature100.slug}:${feature100.version}`
            ) {
              f.max_percentage = 0;
            }
          });
        }
      },
      deep: true,
    },
  },
};
</script>
<style>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); 
  z-index: 999;
}
.custom-modal {
  max-width: 1500px;
  width: 105%;
  margin-left: auto;
  margin-right: auto;
}
</style>
